export const CANVAS_WIDTH = 100;
const CANVAS_HEIGHT = 52;

export const BATTERY_ASPECT_RATIO = CANVAS_HEIGHT / CANVAS_WIDTH; // battery is horizontal
export const BATTERY_BODY = 'batteryBody';
export const BATTERY_CAP = 'batteryCap';
export const BATTERY_METER = 'batteryMeter';
export const READING_TEXT = 'readingText';
export const CHARGING_FLASH = 'chargingFlash';

// clipPath ids
export const CLIP_METER = 'clip_level_meter';
export const CLIP_METER_FILLED = 'clip_level_meter_filled';
export const CLIP_METER_EMPTY = 'clip_level_meter_empty';
export const CLIP_CAP = 'battery_cap_clip';
